// extracted by mini-css-extract-plugin
export var disabled = "_l-9";
export var error = "_l-1";
export var fitContent = "_l-a";
export var hasPrefix = "_l-6";
export var hasSuffix = "_l-4";
export var iconWrapper = "_l-d";
export var infoIconWrapper = "_l-g _l-d";
export var input = "_l-5";
export var inputWrapper = "_l-0";
export var large = "_l-8";
export var leadingIconWrapper = "_l-e _l-d";
export var measureBox = "_l-h";
export var medium = "_l-7";
export var prefix = "_l-c";
export var readonly = "_l-2";
export var small = "_l-3";
export var suffix = "_l-b";
export var trailingIconWrapper = "_l-f _l-d";